import { useFormContext } from 'react-hook-form';
import { AFFILIATE_CAMPAIGN_TYPES } from '@anytag/shared-constants';
import { CampaignTrackingOption, MarketplaceCampaignStatus } from '@anytag/graphql';
import { MarketplaceFormValues } from '../types';
import { CampaignPeriodField, CampaignPeriodFieldProps } from './CampaignPeriodField';

type CampaignPeriodWithLogicsFieldProps = Pick<CampaignPeriodFieldProps, 'required' | 'disabled'>;

export const CampaignPeriodWithLogicsField = (props: CampaignPeriodWithLogicsFieldProps) => {
  const { getValues } = useFormContext<MarketplaceFormValues>();

  const { status, campaignType, trackingOptions } = getValues();
  const isOnGoingCampaign = status === MarketplaceCampaignStatus.ONGOING;
  const hasTrackingPost = trackingOptions.includes(CampaignTrackingOption.POST);
  const isAffiliateCampaign = AFFILIATE_CAMPAIGN_TYPES.includes(campaignType);

  return (
    <CampaignPeriodField
      {...props}
      startDateProps={{ disabled: isOnGoingCampaign }}
      endDateProps={{ optional: isAffiliateCampaign && !hasTrackingPost }}
    />
  );
};
